var exports = {
  "v": "banner__UXJhtx",
};

module.exports = exports;
